export function autosize(elements) {
  // Normalize input to an array of textareas.
  const textareas = elements instanceof window.Node ? [elements] : Array.from(elements || [])

  const listeners = []

  textareas.forEach(textarea => {
    if (!(textarea instanceof window.HTMLTextAreaElement)) return

    // Initial setup: ensure the element can auto-resize vertically.
    const style = window.getComputedStyle(textarea)
    const maxHeight = parseFloat(style.maxHeight)

    const resize = () => {
      // Store the current height so we never shrink below it
      const currentHeight = textarea.clientHeight

      // Temporarily set height to auto so scrollHeight is accurate
      textarea.style.height = 'auto'

      const newHeight = textarea.scrollHeight

      // Only increase height, never shrink
      if (newHeight > currentHeight) {
        if (!isNaN(maxHeight)) {
          textarea.style.height = Math.min(newHeight, maxHeight) + 'px'
        } else {
          textarea.style.height = newHeight + 'px'
        }
      } else {
        // Restore old height if auto produced a smaller value
        textarea.style.height = currentHeight + 'px'
      }
    }

    // Initial measurement
    resize()

    // Event listeners
    const onInput = () => resize()
    const onResize = () => resize() // responsive layouts can change scrollHeight

    textarea.addEventListener('input', onInput)
    window.addEventListener('resize', onResize)

    listeners.push(() => {
      textarea.removeEventListener('input', onInput)
      window.removeEventListener('resize', onResize)
    })
  })

  // Unsubscribe function
  return function unsubscribe() {
    listeners.forEach(fn => fn())
  }
}
